import { useMutation } from '@apollo/client'
import { Button, TextField, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { addJob } from '../../cache/jobs'
import SectionTitle from '../../components/SectionTitle'
import {
  CONFIRM_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION,
  REJECT_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION
} from '../../graphql/walletPaymemt'
import { getTodayDate } from '../../helpers/date'
import { getTranslate } from '../../localization'
import { JobsType } from '../../mockData/jobs'
import useStyles from './styles/Confirmation'

const ReceiptConfirmation: React.FC = () => {
  const classes = useStyles()
  const params = useParams<{ proformaId: string }>()

  const [description, setDescription] = useState('')
  const [confirmPayment] = useMutation(
    CONFIRM_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION,
    {
      onCompleted: (resp) => {
        const newJob: JobsType = {
          trackID: resp.confirmOfflinePaymentOfProforma.trackingID,
          creationDate: getTodayDate(),
          status: 'InProgress'
        }
        addJob(newJob)
        toast.info(
          getTranslate(
            `payment job with tracking id ${resp.confirmOfflinePaymentOfProforma.trackingID} started`
          )
        )
      },
      onError: (err) => {
        toast.error(err.message)
      }
    }
  )

  const [rejectPayment] = useMutation(
    REJECT_OFFLINE_PAYMENT_OF_PROFORMA_MUTATION,
    {
      onCompleted: () => {
        toast.success(getTranslate(`offline payment rejected successfully`))
      },
      onError: (err) => {
        toast.error(err.message)
      }
    }
  )

  const onConfirm = () => {
    if (description) {
      confirmPayment({
        variables: {
          input: { proformaID: params.proformaId, description: description }
        }
      })
    }
  }

  const onReject = () => {
    if (description) {
      rejectPayment({
        variables: {
          input: { proformaID: params.proformaId, description: description }
        }
      })
    }
  }
  return (
    <div>
      <SectionTitle title="Confirmation" marginBottom />

      <div className={classes.container}>
        <Typography className={classes.label}>
          {getTranslate('Check the received receipt')}
        </Typography>

        <Button
          onClick={onConfirm}
          disabled={!description}
          variant="contained"
          fullWidth
          color="primary"
          className={classes.confirmButton}>
          {getTranslate('Confirm')}
        </Button>

        <TextField
          multiline
          rows={4}
          placeholder={getTranslate('Description')}
          variant="outlined"
          fullWidth
          className={classes.textArea}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />

        <Button
          disabled={!description}
          variant="outlined"
          fullWidth
          className={classes.rejectButton}
          onClick={onReject}>
          {getTranslate('Reject')}
        </Button>
      </div>
    </div>
  )
}

export default ReceiptConfirmation
